import React, { ReactElement, useState } from 'react';
import styled from 'styled-components/macro';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';
import { CheckedCheckbox } from 'assets/icons';
import { Box, HStack } from '@televet/kibble-ui/build/chakra';

interface Props {
  index: number;
  prompt: string;
  defaultValue: boolean;
  isRequired: boolean;
}

const Checkbox = ({ index, prompt, defaultValue, isRequired }: Props): ReactElement => {
  const [isChecked, setIsChecked] = useState(defaultValue);
  const handleToggle = (): void => {
    setIsChecked(!isChecked);
  };
  return (
    <QuestionWrapper index={index}>
      <HStack spacing={2.5}>
        {isChecked ? <CustomCheckedCheckbox onClick={handleToggle} /> : <CustomEmptyCheckbox onClick={handleToggle} />}
        <Box width="92%">
          <Prompt inline prompt={prompt} isRequired={isRequired} />
        </Box>
      </HStack>
    </QuestionWrapper>
  );
};

export default Checkbox;

const CustomCheckedCheckbox = styled(CheckedCheckbox)`
  width: 20px;
  height: 20px;
  border-radius: 2px;
  background-color: var(--chakra-colors-background-default);
  cursor: pointer;
`;

const CustomEmptyCheckbox = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: solid 1.5px var(--chakra-colors-text-default);
  background-color: var(--chakra-colors-background-default);
`;
